/* import __COLOCATED_TEMPLATE__ from './body.hbs.js'; */
/**
 *
 * Modal body element used within [Components.Modal](Components.Modal.html) components. See there for examples.
 *
 * @class ModalBody
 * @namespace Components
 * @extends Glimmer.Component
 * @public
 */
import templateOnly from '@ember/component/template-only';
export default templateOnly();